module.exports = __webpack_public_path__ + "images/awardee.svg?6ee1e49abfe14e4da9241202bc77f9b8";


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/views/progress/components/result/components/progress/components/icons/images/awardee.svg
// module id = cf85e8abd9068f4b43e4
// module chunks = 11